import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DockPanel.css';

// NER-1563: the right dock now hosts Citame quick actions instead of the Resto
// widgets (orders/cash/tables/alerts). Each action deep-links to a real admin
// flow. The dock is always available (Citame admin is single-mode).
const DockPanel = ({ isExpanded, onToggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'new-appointment',
      icon: 'event_available',
      label: t('dock.newAppointment', 'Nuevo turno'),
      path: '/agenda',
    },
    {
      id: 'professionals',
      icon: 'badge',
      label: t('nav.professionals', 'Profesionales'),
      path: '/professionals',
    },
    {
      id: 'services',
      icon: 'medical_services',
      label: t('nav.services', 'Servicios'),
      path: '/services',
    },
    {
      id: 'conversations',
      icon: 'chat',
      label: t('nav.conversations', 'Conversaciones'),
      path: '/conversations',
    },
    {
      id: 'settings',
      icon: 'settings',
      label: t('nav.settings', 'Ajustes'),
      path: '/settings',
    },
  ];

  const go = (path) => navigate(path);

  return (
    <div className={`dock-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      {/* Collapsed state - icon bar */}
      {!isExpanded && (
        <div className="dock-collapsed-bar">
          <button
            type="button"
            className="dock-expand-btn"
            onClick={() => onToggle(true)}
            title={t('dock.expand', 'Expandir')}
            aria-label={t('dock.expand', 'Expandir')}
          >
            <span className="material-icons">chevron_left</span>
          </button>
          {quickActions.map((action) => (
            <button
              type="button"
              key={action.id}
              className="dock-collapsed-icon"
              onClick={() => go(action.path)}
              title={action.label}
              aria-label={action.label}
            >
              <span className="material-icons">{action.icon}</span>
            </button>
          ))}
        </div>
      )}

      {/* Expanded state - full panel */}
      {isExpanded && (
        <div className="dock-expanded">
          <div className="dock-header">
            <span className="dock-title">
              <span className="material-icons">bolt</span>
              {t('dock.quickActions', 'Acciones rápidas')}
            </span>
            <button
              type="button"
              className="dock-collapse-btn"
              onClick={() => onToggle(false)}
              title={t('dock.collapse', 'Colapsar')}
              aria-label={t('dock.collapse', 'Colapsar')}
            >
              <span className="material-icons">chevron_right</span>
            </button>
          </div>

          <div className="dock-widgets">
            {quickActions.map((action) => (
              <button
                type="button"
                key={action.id}
                className="dock-quick-action"
                onClick={() => go(action.path)}
              >
                <span className="material-icons">{action.icon}</span>
                <span className="dock-quick-action-label">{action.label}</span>
                <span className="material-icons dock-quick-action-arrow">chevron_right</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DockPanel;
